module.exports = __webpack_public_path__ + "img/组 3.8c0174c1.webp";